import { FailureToast, SuccessToast } from "components/Toast";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const useToastMessage = (updated, invalidate, error, name) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (!updated && !error) {
      return;
    }

    if (updated) {
      toast(
        <SuccessToast
          heading={`Success`}
          description={`${name} saved successfully`} />,
          {
            type: toast.TYPE.DEFAULT,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          }
      );

      dispatch(invalidate());

    } else if (error) {
      toast(
        <FailureToast
          heading={`Failure`}
          description={`Unable to save ${name.toLowercase()}`} />,
          {
            type: toast.TYPE.DEFAULT,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          }
      );

      dispatch(invalidate());
    }
  }, [updated]);
};
  
  export default useToastMessage;